import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import React from 'react'

import { ChatRoomPage } from 'pages/ChatRoom'

import { Box } from 'widgets/Box'

interface CommentsPageProps {
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}

export const CommentsPage = ({ drawerNavigationRef, ...rest }: CommentsPageProps) => {
  const { roomId, postId, completionId } = rest?.data?.routeOptions

  return (
    <Box testID='CommentPage' flexDirection='column' backgroundColor='white' flex={1}>
      <ChatRoomPage
        chatroomId={roomId}
        commentPostId={postId}
        commentCompletionId={completionId}
        isBottomSheetPresentation
        drawerNavigationRef={drawerNavigationRef}
      />
    </Box>
  )
}
